import { render } from "./ProductDetailView.vue?vue&type=template&id=4bdbe3c0&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"

import "./ProductDetailView.vue?vue&type=style&index=0&id=4bdbe3c0&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdbe3c0"]])

export default __exports__